<template>
  <div>
    <!-- ------------------START FORMULARIO PRE COTACAO------------------------ -->
    <vs-card class="mb-6">
      <div slot="header">
        <h3>Pre Cotação</h3>
      </div>
      <form role="form" @submit.stop.prevent="buscar">
        <vs-row>
          <vs-col
            class="mb-2"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="4"
            vs-sm="4"
            vs-xs="12"
          >
            <vs-input
              class="w-full"
              label="Nome"
              v-model="form.nome"
              name="Nome"
              v-validate="{ required: true }"
              :state="validateState('Nome')"
              :class="validateClass('Nome')"
              :disabled="mostrarProdutos"
            />
          </vs-col>
          <vs-col
            class="mb-2"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="4"
            vs-sm="4"
            vs-xs="12"
          >
            <vs-input
              class="w-full"
              label="Celular"
              v-model="form.celular"
              name="Celular"
              v-mask="'(##) # ####-####'"
              v-validate="{ required: true, min: 15 }"
              :state="validateState('Celular')"
              :class="validateClass('Celular')"
              :disabled="mostrarProdutos"
            />
          </vs-col>
          <vs-col
            class="mb-2"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="4"
            vs-sm="4"
            vs-xs="12"
          >
            <vs-input
              class="w-full"
              label="Email"
              v-model="form.email"
              name="Email"
              v-validate="{ email: true }"
              :state="validateState('Email')"
              :class="validateClass('Email')"
              :disabled="mostrarProdutos"
            />
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col class="mb-2" vs-lg="6" vs-sm="6" vs-xs="12">
            <label for="" class="vs-select--label">Estado</label>
            <v-select
              :options="estados"
              name="Estado"
              id="Estado"
              @input="
                buscaDadosSelectsCidades(
                  'domMunicipio',
                  'cidades',
                  'nomeCidade',
                  'idCidade',
                ),
                  selecionaEstado()
              "
              v-model="estado"
              v-validate="{ required: true }"
              label="label"
              :state="validateState('Estado')"
              :class="validateClass('Estado')"
              :disabled="mostrarProdutos"
            ></v-select>
          </vs-col>
          <vs-col class="mb-2" vs-lg="6" vs-sm="6" vs-xs="12">
            <label for="" class="vs-select--label">Cidade</label>
            <v-select
              :options="cidades"
              name="Cidade"
              id="Cidade"
              @input="selecionaCidade()"
              v-model="cidade"
              v-validate="{ required: true }"
              label="label"
              :state="validateState('Cidade')"
              :class="validateClass('Cidade')"
              :disabled="mostrarProdutos"
            ></v-select>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col
            class="mb-2"
            :vs-lg="showCilindrada ? '2' : '3'"
            vs-sm="6"
            vs-xs="12"
          >
            <label>Tenho a placa do veículo?</label>
            <vs-switch
              class="mb-3"
              v-model="temPlaca"
              style="width: 60px"
              :disabled="mostrarProdutos"
            >
              <span slot="on">Sim</span>
              <span slot="off">Não</span>
            </vs-switch>
          </vs-col>
          <vs-col class="mb-2" vs-lg="2" vs-sm="6" vs-xs="12" v-if="temPlaca">
            <vs-input
              id="placa"
              name="Placa"
              label="Placa"
              v-model="form.placa"
              class="w-full"
              v-validate="{ required: true, min: 8 }"
              v-mask="'AAA-#XX#'"
              :state="validateState('Placa')"
              :class="validateClass('Placa')"
              @change="keymonitorPlaca"
              :disabled="mostrarProdutos"
            />
          </vs-col>
          <vs-col class="mb-2" vs-lg="2" vs-sm="6" vs-xs="12" v-if="!temPlaca"
            ><span>Valor do Veículo</span>
            <money
              class="vs-inputx vs-input--input normal"
              name="Valor do Veículo"
              id="Valor do Veículo"
              v-model="form.valor"
              v-validate="{ required: true }"
              :state="validateState('Valor do Veículo')"
              :danger="validateClass('Valor do Veículo')"
              v-bind="money"
              :disabled="mostrarProdutos"
            ></money>
          </vs-col>
          <vs-col
            class="mb-2"
            :vs-lg="showCilindrada ? 2 : 3"
            vs-sm="6"
            vs-xs="12"
          >
            <label for="" class="vs-select--label">Tipo do Veículo</label>
            <v-select
              :options="tiposFipe"
              name="Tipo do Veículo"
              id="Tipo do Veículo"
              v-model="tipoFipe"
              @input="abrirModalGrupos(tipoFipe)"
              v-validate="{ required: true }"
              label="label"
              :state="validateState('Tipo do Veículo')"
              :class="validateClass('Tipo do Veículo')"
              :disabled="mostrarProdutos"
            ></v-select>
          </vs-col>
          <vs-col
            class="mb-2"
            :vs-lg="escolherGrupo ? 3 : 4"
            vs-sm="11"
            vs-xs="10"
          >
            <vs-input
              name="Grupo do Veículo"
              id="Grupo do Veículo"
              class="w-full"
              label="Grupo do Veículo"
              v-validate="{ required: true }"
              v-model="form.idGrupo.label"
              :state="validateState('Grupo do Veículo')"
              :class="validateClass('Grupo do Veículo')"
              :disabled="true"
            />
          </vs-col>
          <vs-col
            class="mb-2 trocaGrupoContainer"
            vs-lg="1"
            vs-sm="1"
            vs-xs="2"
            vs-type="flex"
            vs-justify="flex-start"
            vs-align="flex-end"
            v-if="escolherGrupo"
          >
            <vs-button
              v-tooltip="'trocar Grupo do Veículo'"
              radius
              color="primary"
              type="gradient"
              icon-pack="feather"
              icon="icon-refresh-ccw"
              class="d-inline"
              @click="mostrarModalGrupos = true"
              :disabled="mostrarProdutos"
            ></vs-button>
          </vs-col>
          <vs-col
            class="mb-2"
            vs-lg="2"
            vs-sm="6"
            vs-xs="12"
            v-if="showCilindrada"
          >
            <vs-input
              label="Cilindradas"
              class="w-full"
              name="Cilindrada"
              id="Cilindrada"
              type="number"
              v-model="form.veiculo.cilindradas"
              v-validate="{ required: true }"
              :state="validateState('Cilindrada')"
              :danger="validateClass('Cilindrada')"
              :disabled="mostrarProdutos"
            />
          </vs-col>
        </vs-row>

        <!-- --------------------START VEICULOS POSSIVEIS------------------- -->
        <vs-alert
          v-if="mostrarVeiculosPossiveis"
          active="true"
          color="primary"
          :title="listaVeiculosPossiveis.titulo"
          style="height: auto !important"
        >
          <div class="p-3 mb-3">
            Encontramos {{ listaVeiculosPossiveis.total }} modelos que se
            assemelham ao seu veículo, selecione o Modelo correto.
          </div>
          <vs-list>
            <vs-list-item
              v-for="(veiculo, index) in listaVeiculosPossiveis.todosScores"
              :key="index"
              :title="veiculo.texto_modelo"
              :subtitle="`${veiculo.codigo_fipe}  /  ${veiculo.ano_modelo}-${
                veiculo.combustivel
              } 
              ${veiculo.score ? '(score-' + veiculo.score + ')' : ''}`"
            >
              <vs-radio
                color="rgb(47,53,102)"
                v-model="radioSelecionado"
                :vs-value="veiculo.codigo_fipe"
                @change="selecionaModelo(veiculo)"
              ></vs-radio>
            </vs-list-item>
            <vs-list-item title="Nenhum dos modelos Acima">
              <vs-radio
                color="rgb(47,53,102)"
                v-model="radioSelecionado"
                :vs-value="'nenhum'"
                @change="(temPlaca = false), (mostrarVeiculosPossiveis = false)"
              ></vs-radio>
            </vs-list-item>
          </vs-list>
        </vs-alert>
        <!---------------END VEICULOS POSSIVEIS-------------------->

        <!-- ------------START VALORES DE COBERTURA ----------------->
        <vs-row v-if="mostrarVeiculosPossiveis">
          <vs-col vs-w="12">
            <h4 class="mb-3 mt-6">Valores de Cobertura</h4>
            <hr class="mb-6" />
          </vs-col>

          <vs-col class="flex-col mb-3" vs-align="flex-start" vs-w="6">
            <label for class="vs-input--label">Preço FIPE</label>
            <money
              class="vs-inputx vs-input--input normal"
              name="Preço Fipe"
              id="Preço Fipe"
              v-model="form.valor"
              v-validate="{ required: true }"
              :state="validateState('Preço Fipe')"
              :danger="validateClass('Preço Fipe')"
              v-bind="money"
              :disabled="true"
            ></money>
          </vs-col>
          <vs-col class="flex-col mb-3" vs-align="flex-start" vs-w="6"
            ><label for class="vs-input--label">Valor de Cobertura</label>
            <money
              class="vs-inputx vs-input--input normal"
              name="Valor de Cobertura"
              id="Valor de Cobertura"
              v-model="form.valor"
              v-validate="{ required: true }"
              :state="validateState('Valor de Cobertura')"
              :danger="validateClass('Valor de Cobertura')"
              v-bind="money"
              :disabled="true"
            ></money
          ></vs-col>
        </vs-row>
        <!-- ------------END VALORES DE COBERTURA ----------------->

        <!-- ------------START ERROS----------------->
        <vs-alert
          v-if="errosArray.length > 0"
          color="danger"
          title="Atenção!!"
          active="true"
          class="my-3"
          style="height: auto !important"
        >
          <ul>
            <li class="mb-2" v-for="(error, index) in errosArray" :key="index">
              {{ error }}
            </li>
          </ul>
        </vs-alert>
        <!-- ------------END ERROS----------------->

        <div class="vx-row">
          <div class="vx-col w-full text-right">
            <vs-button
              v-show="!mostrarProdutos"
              color="success"
              type="filled"
              class="mr-3 mt-2 mb-2"
              @click="fazerBusca = true"
              >Buscar</vs-button
            >
            <vs-button
              v-show="mostrarProdutos"
              @click="editar"
              color="primary"
              type="filled"
              class="mr-3 mt-2 mb-2"
              :disabled="!mostrarProdutos"
              >Editar</vs-button
            >
          </div>
        </div>
      </form>
      <!-- --------------------END FORMULARIO PRE COTACAO-------------------------- -->

      <!-- --------------------START PRODUTOS-------------------------- -->
      <div v-if="mostrarProdutos">
        <vs-row>
          <vs-col class="mb-2" vs-lg="6" vs-sm="6" vs-xs="12">
            <vs-list>
              <vs-list-header title="Produtos Obrigatórios"></vs-list-header>
              <ul class="centerx">
                <li
                  v-for="produto in produtosObrigatorios"
                  :key="produto.id_produto"
                >
                  <div class="container">
                    <vs-checkbox disabled="true" :checked="!produto.excluido">
                    </vs-checkbox>
                    <vs-list-item
                      :title="produto.nomeProduto"
                      :subtitle="`R$ ${produto.valor.toFixed(2)} ${
                        produto.ismensal == true ? '/mês' : ''
                      }`"
                    >
                    </vs-list-item>
                  </div>
                </li>
              </ul>
            </vs-list>
          </vs-col>
          <vs-col class="mb-2" vs-lg="6" vs-sm="6" vs-xs="12">
            <vs-list>
              <vs-list-header title="Produtos Opcionais"></vs-list-header>
              <ul class="centerx">
                <li
                  v-for="produto in produtosOpcionais"
                  :key="produto.id_produto"
                >
                  <div class="container">
                    <vs-checkbox
                      @input="processarProdutos(produto)"
                      v-model="produto.selecionado"
                      :vs-value="produto.id_produto"
                    >
                    </vs-checkbox>
                    <vs-list-item
                      :title="produto.nomeProduto"
                      :subtitle="`R$ ${produto.valor.toFixed(2)} ${
                        produto.ismensal == true ? '/mês' : ''
                      }`"
                    >
                    </vs-list-item>
                  </div>
                </li>
              </ul>
            </vs-list>
          </vs-col>
        </vs-row>
        <hr class="my-2" />
        <vs-row>
          <vs-col class="mb-2" vs-lg="6" vs-sm="6" vs-xs="12">
            <h6 class="mt-5">
              <span id="total">Total Mensal:</span>
              {{ somaValorTotalMes | currency }}
            </h6>
          </vs-col>
          <vs-col class="mb-2" vs-lg="6" vs-sm="6" vs-xs="12">
            <h6 class="mt-5">
              <span id="total">Total Entrada:</span>
              {{ somaValorTotal | currency }}
            </h6>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-type="flex" vs-justify="flex-end">
            <vs-button
              @click="salvar()"
              color="dark"
              type="gradient"
              class="mt-2 mb-2"
              >Salvar</vs-button
            >
          </vs-col>
        </vs-row>
      </div>
    </vs-card>
    <!-- --------------------END PRODUTOS-------------------------- -->

    <!-- --------------------START MODAL GRUPOS-------------------------- -->
    <vs-popup
      v-if="mostrarModalGrupos"
      class="holamundo"
      :title="'Grupo de Veículos'"
      :active.sync="mostrarModalGrupos"
    >
      <vs-list>
        <vs-list-item
          v-for="(grupoTipo, index) in gruposPorTipo"
          :key="index"
          :title="grupoTipo.label"
          :subtitle="grupoTipo.descricao"
        >
          <vs-radio
            color="rgb(47,53,102)"
            v-model="form.idGrupo"
            :vs-value="grupoTipo"
          ></vs-radio>
        </vs-list-item>
      </vs-list>
      <vs-row>
        <vs-col vs-type="flex" vs-justify="flex-end">
          <vs-button
            @click="mostrarModalGrupos = false"
            color="primary"
            type="gradient"
            class="mr-3 mt-2 mb-2"
            :disabled="!Object.hasOwn(form.idGrupo, 'label')"
            >Escolher</vs-button
          >
        </vs-col>
      </vs-row>
    </vs-popup>
    <!-- --------------------END MODAL GRUPOS-------------------------- -->
  </div>
</template>
<script>
import locale from '../../locale';
import service from '../../services/index';
import vSelect from 'vue-select';
import { Money } from 'v-money';
import jwt from 'jsonwebtoken';
import { decryptData } from '../../services/decryptData';

export default {
  data() {
    return {
      form: {
        idUsuarioConsultor: null,
        nome: null,
        celular: null,
        email: null,
        estado: null,
        cidade: null,
        placa: '',
        valor: '',
        valorCobertura: '',
        idGrupo: {},
        veiculo: {
          cilindradas: null,
          resultFipe: {},
        },
      },
      estados: [],
      cidades: [],
      tiposFipe: [],
      tipoFipe: null,
      grupos: [],
      gruposPorTipo: [],
      estado: null,
      cidade: null,
      temPlaca: true,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: true,
      },
      errosArray: [],
      showCilindrada: false,
      dadosPlaca: null,
      produtosObrigatorios: [],
      produtosOpcionais: [],
      produtosCotacao: [],
      listaVeiculosPossiveis: {
        titulo: '',
        total: 0,
        todosScores: [],
      },
      radioSelecionado: '',
      modeloSeleciondo: {},
      grupo: {},
      dadosFipeModelo: {},
      mostrarVeiculosPossiveis: false,
      mostrarProdutos: false,
      fazerBusca: false,
      escolherGrupo: false,
      mostrarModalGrupos: false,
      modeloConfirmado: false,
      dicionarioTiposVeiculos: {},
    };
  },
  watch: {
    estado() {
      if (this.estado === null) {
        this.cidade = null;
        this.cidades = [];
      }
    },
    'form.idGrupo': function (newValue) {
      if (newValue !== null) {
        this.grupo = newValue;
        if (newValue.idTipoFipe == 2) {
          this.showCilindrada = true;
        } else {
          this.showCilindrada = false;
        }
      }
    },
    temPlaca() {
      if (this.temPlaca) {
        this.form.placa = '';
        this.showCilindrada = false;
        this.tipoFipe = null;
        this.form.idGrupo = {};
        this.escolherGrupo = false;
      } else {
        this.form.placa = '';
        this.form.valor = '';
        this.form.veiculo.cilindradas = null;
        this.mostrarVeiculosPossiveis = false;
        this.form.idGrupo = {};
        this.tipoFipe = null;
        this.dadosPlaca = {};
        this.modeloSeleciondo = {};
        this.dadosFipeModelo = {};
        this.modeloConfirmado = true;
      }
    },
  },
  computed: {
    somaValorTotalMes() {
      return this.produtosCotacao.reduce((acc, curr) => {
        if (curr.ismensal) {
          acc += curr.valor;
        }
        return acc;
      }, 0);
    },
    somaValorTotal() {
      return this.produtosCotacao.reduce((acc, curr) => {
        if (!curr.ismensal) {
          acc += curr.valor;
        }
        return acc;
      }, 0);
    },
  },
  created() {
    this.$validator.localize('ptBr', locale);
  },
  mounted() {
    this.buscaDadosGrupos();
    this.buscaDadosSelects('domUf', 'estados', 'nomeUf', 'codUf');
    this.buscaDadosSelects(
      'domTipoFipe',
      'tiposFipe',
      'nomeTipo',
      'idTipoFipe',
    );
    this.buscarDicionarioTiposVeiculos();
    const token = localStorage.getItem('user-token');
    if (token) {
      this.decoded = jwt.decode(token);
      this.form.idEmpresa = this.decoded.id_empresa;
      this.form.idUsuarioConsultor = this.decoded.id_usuario;
    }
  },
  methods: {
    pegaridEmpresa() {
      return localStorage.getItem('idEmpresa');
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref) ? 'has-error' : '';
      }
      return null;
    },
    validarCampos() {
      this.errosArray = this.$validator.errors.all();
      const erros = {
        valorInvalido: 'O Valor do Veículo é inválido',
      };

      let semErros = true;

      if (!this.temPlaca && +this.form.valor.slice(3).replace(',', '.') <= 0) {
        this.errosArray.push(erros.valorInvalido);
        semErros = false;
      }

      if (
        this.temPlaca &&
        this.form.placa &&
        !Object.hasOwn(this.modeloSeleciondo, 'anoModelo')
      ) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `Por favor, confirme o modelo do veículo ou clique em "Nenhum dos modelos Acima"`,
          color: 'danger',
        });
      }

      if (semErros) {
        this.errosArray = this.errosArray.filter(
          (error) => error !== erros.valorInvalido,
        );
      }
    },
    selecionaEstado() {
      if (this.estado !== null) {
        var aux = this.estados.find((x) => x.id == this.estado.id);
        this.form.estado = aux.label;
      }
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data = decryptData(res.data);
        res.data.forEach((element) => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao],
          });
        });

        this[array].sort(function (a, b) {
          return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
        });
      });
    },
    buscaDadosSelectsCidades(model, array, campoDescricao, campoPK) {
      if (this.estado !== null) {
        this.$vs.loading();
        this[array] = [];
        service
          .getAll('g', {}, `${model}/list/codUf/${this.estado.id}`)
          .then((res) => {
            res.data = decryptData(res.data);
            res.data.forEach((element) => {
              this[array].push({
                id: element[campoPK],
                label: element[campoDescricao],
              });
            });
            this.$vs.loading.close();
          });
      }
    },
    selecionaCidade() {
      var aux = this.cidades.find((x) => x.id == this.cidade.id);
      this.form.cidade = aux.label;
    },
    buscaDadosGrupos() {
      service
        .getAll('Grupo', {}, 'list/idEmpresa=' + this.idEmpresa)
        .then((res) => {
          res.data.forEach((element) => {
            if (element.deletedAt == null)
              this.grupos.push({
                id: element.idGrupo,
                label: element.nomeGrupo,
                idTipoFipe: element.idTipoFipe,
                descricao: element.descricao,
              });
          });
        });
    },
    keymonitorPlaca() {
      console.log(this.form.placa.length);
      if (this.form.placa.length == 8) {
        this.buscaDadosPlaca();
      }
    },
    buscaDadosPlaca() {
      if (this.form.placa.length == 8) this.$vs.loading();
      this.radioSelecionado = '';
      this.escolherGrupo = false;
      this.modeloSeleciondo = {};
      this.modeloConfirmado = false;
      this.form.idGrupo = {};
      this.tipoFipe = null;
      this.form.valor = '';
      service
        .post('CotacaoAberta', `BuscaDadosPlaca`, { placa: this.form.placa })
        .then((res) => {
          if (
            !res.data ||
            res.data.mensagemRetorno.includes(
              'Nenhum veículo foi encontrado',
            ) ||
            !res.data.fipe.dados ||
            !res.data.extra ||
            res.data.fipe.dados.length === 0
          ) {
            this.form.placa = '';
            this.temPlaca = false;
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: `Nenhum modelo foi encontrado com a placa fornecida`,
              color: 'danger',
            });
          } else {
            this.dadosPlaca = res.data;
            this.pegarVeiculosPossiveis();
            this.pegaIdTipoFipe();
            this.$vs.loading.close();
          }
        })
        .catch(() => {
          this.form.placa = '';
          this.temPlaca = false;
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: `Nenhum modelo foi encontrado com a placa fornecida`,
            color: 'danger',
          });
        });
    },
    buscarDicionarioTiposVeiculos() {
      service
        .post('dicionarios', 'buscar-dicionario-tipos-veiculos', {})
        .then((res) => {
          this.dicionarioTiposVeiculos = res.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    pegaIdTipoFipe() {
      if (this.dadosPlaca.extra.tipo_veiculo) {
        const tipoVeiculo =
          this.dicionarioTiposVeiculos[this.dadosPlaca.extra.tipo_veiculo];
        this.reatribuirTipoFipe(tipoVeiculo.codigoTipo);
      }
    },
    reatribuirTipoFipe(id) {
      const tipo = this.tiposFipe.filter((tipo) => id === tipo.id);
      this.tipoFipe = tipo[0];
    },
    pegarVeiculosPossiveis() {
      this.listaVeiculosPossiveis.titulo = this.dadosPlaca.marcaModelo;
      this.listaVeiculosPossiveis.total = this.dadosPlaca.fipe.dados.length;
      this.listaVeiculosPossiveis.todosScores = this.dadosPlaca.fipe.dados.sort(
        (a, b) => (a.score > b.score ? -1 : a.score < b.score ? 1 : 0),
      );
      this.mostrarVeiculosPossiveis = true;
    },
    selecionaModelo(item) {
      this.$vs.loading();
      this.modeloSeleciondo = this.listaVeiculosPossiveis.todosScores.find(
        (e) => e.codigo_fipe === item.codigo_fipe,
      );
      this.buscarDadosFipeModelo();
    },
    buscarDadosFipeModelo() {
      const modelo = this.modeloSeleciondo;
      modelo.codigoTipoVeiculo = modelo.tipo_modelo;
      modelo.anoModelo = this.dadosPlaca.anoModelo;
      service
        .post('CotacaoAberta', 'BuscaDadosFipeModelo', modelo)
        .then((res) => {
          this.dadosFipeModelo = res.data;
          this.form.valor = res.data.preco;
          this.form.valorCobertura = this.form.valor;
          this.form.veiculo.resultFipe.preco = this.form.valor;
          if (
            res.data.tipo === 2 &&
            this.dadosPlaca.extra &&
            this.dadosPlaca.extra.cilindradas
          ) {
            this.form.veiculo.cilindradas = this.dadosPlaca.extra.cilindradas;
          }

          this.buscaGrupoMarcaModelo(res.data);
        })
        .catch(() => {
          this.form.placa = '';
          this.temPlaca = false;
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: `ocorreu um erro ao validar o modelo`,
            color: 'danger',
          });
        });
    },
    buscaGrupoMarcaModelo(data) {
      const idMarca = data.id_marca;
      const idModelo = data.id_modelo;
      const tipo = data.tipo;
      const _idEmpresa = localStorage.getItem('idEmpresa');
      const objBuscaGrupo = { idEmpresa: _idEmpresa, idMarca, idModelo, tipo };
      service
        .post('CotacaoAberta', 'buscaGrupoMarcaModelo', objBuscaGrupo)
        .then((res) => {
          if (res.data.length === 1) {
            this.form.idGrupo = this.grupos.find(
              (grupo) => res.data[0].id === grupo.id,
            );
            this.reatribuirTipoFipe(res.data[0].idTipoFipe);
            this.$vs.loading.close();
            this.grupo = res.data[0];
          } else {
            this.$vs.loading.close();
            this.abrirModalGrupos(data, res.data);
          }
          this.modeloConfirmado = true;
        })
        .catch(() => {
          this.form.placa = '';
          this.temPlaca = false;
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: `ocorreu um erro ao buscar grupos para o modelo selecioando`,
            color: 'danger',
          });
        });
    },
    abrirModalGrupos(data, gruposEncontrados) {
      this.form.idGrupo = {};
      const separarGrupos =
        gruposEncontrados && gruposEncontrados.length !== 0 ? true : false;
      const grupos = separarGrupos ? gruposEncontrados : this.grupos;
      this.gruposPorTipo = grupos.filter(
        (grupo) => grupo.idTipoFipe === (data.tipo || data.id),
      );
      this.mostrarModalGrupos = true;
      this.escolherGrupo = true;
      this.$vs.notify({
        position: 'top-center',
        title: 'Atenção',
        text: `Por favor, selecione o grupo do veículo manualmente`,
        color: 'warning',
      });
    },
    editar() {
      this.mostrarProdutos = false;
      if (this.temPlaca) {
        this.mostrarVeiculosPossiveis = true;
      }
    },
    async buscar() {
      await this.$validator.validateAll();
      this.validarCampos();
      if (
        this.errosArray.length === 0 &&
        this.fazerBusca &&
        this.modeloConfirmado
      ) {
        this.mostrarVeiculosPossiveis = false;
        this.form.veiculo.resultFipe.preco = this.form.valor;
        this.form.valorCobertura = this.form.valor;
        if (this.form.idGrupo.idTipoFipe !== 2) {
          this.form.veiculo.cilindradas = null;
        }
        this.$vs.loading();
        service
          .post('Cotacao', 'BuscaProdutos', this.form)
          .then((res) => {
            this.$vs.loading.close();
            this.fazerBusca = false;
            if (res.data.length == 0) {
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: `Nenhum Produto Encontrado para essa faixa`,
                color: 'danger',
              });
            } else {
              this.fazerBusca = false;
              this.separarProdutos(res.data);
              this.mostrarProdutos = true;
            }
          })
          .catch(() => {
            this.fazerBusca = false;
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'erro ao buscar produtos por favor tente novamente',
              color: 'danger',
            });
          });
      }
    },
    separarProdutos(data) {
      this.produtosObrigatorios = data
        .filter((produto) => produto.obrigatorio)
        .map((produto) => {
          produto.excluido = false;
          return produto;
        });
      this.produtosOpcionais = data
        .filter((produto) => !produto.obrigatorio)
        .map((produto) => {
          produto.selecionado = false;
          return produto;
        });
      this.produtosDaCotacao();
    },
    processarProdutos(produto) {
      this.linkaProdutos(produto);
      this.sobrepoeProdutos(produto);
      this.produtosDaCotacao();
    },
    linkaProdutos(prod) {
      const produtosLinkados = prod.produtosLinkados.split(',');
      produtosLinkados &&
        produtosLinkados.forEach((id) => {
          this.produtosObrigatorios = this.produtosObrigatorios.map((produto) =>
            produto.id_produto === +id
              ? { ...produto, excluido: prod.selecionado }
              : produto,
          );
          this.produtosOpcionais = this.produtosOpcionais.map((produto) =>
            produto.id_produto === +id
              ? { ...produto, selecionado: prod.selecionado }
              : produto,
          );
        });
    },
    sobrepoeProdutos(prod) {
      const produtosSobrepostos = prod.sobreporOutrosProdutos.split(',');
      produtosSobrepostos &&
        produtosSobrepostos.forEach((id) => {
          this.produtosObrigatorios = this.produtosObrigatorios.map((produto) =>
            produto.id_produto === +id
              ? { ...produto, excluido: prod.selecionado ? true : false }
              : produto,
          );
          this.produtosOpcionais = this.produtosOpcionais.map((produto) =>
            produto.id_produto === +id
              ? { ...produto, selecionado: false }
              : produto,
          );
        });
    },
    produtosDaCotacao() {
      this.produtosCotacao = this.produtosObrigatorios
        .concat(this.produtosOpcionais)
        .filter((produto) => produto.excluido === false || produto.selecionado);
    },
    async salvar() {
      this.fazerBusca = false;
      this.form.produtos = this.produtosCotacao;
      this.form.dadosPlaca = this.dadosPlaca || null;
      this.form.modelo = this.modeloSeleciondo || null;
      this.form.dadosFipeModelo = this.dadosFipeModelo || null;
      this.form.grupoSeleciondo = this.grupo || null;

      this.$vs.loading();
      service
        .post('PreCotacao', 'CadastrarPreCotacao', this.form)
        .then(() => {
          this.$vs.loading.close();
          this.voltarParaPreCotacoes();
        })
        .catch(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'erro ao salvar a proposta, por favor tente novamente',
            color: 'danger',
          });
        });
    },
    voltarParaPreCotacoes() {
      this.$router.go(-1);
    },
  },
  components: {
    'v-select': vSelect,
    Money,
  },
};
</script>
<style scoped>
.container {
  display: flex;
  flex-direction: row;
}
.trocaGrupoContainer {
  padding: 0px 0px 0px 0px !important;
}

#total {
  color: #3fc0ed;
  font-weight: 700;
}
h6 {
  font-weight: 700;
}
</style>
